import * as React from "react";
import { IconButton, Icon, IconConstants, makeStyles } from "componentLibrary";
import classNames from "classnames";
import { jsx as _jsx } from "react/jsx-runtime";
export default function ClearButton(_ref) {
  var onClick = _ref.onClick,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? "small" : _ref$size,
    className = _ref.className;
  var useStyles = makeStyles(function () {
    return {
      clearButton: {
        padding: "4px",
        width: "24px"
      }
    };
  });
  var classes = useStyles();
  return /*#__PURE__*/_jsx(IconButton, {
    onClick: onClick,
    size: size,
    className: classNames(className, classes.clearButton),
    children: /*#__PURE__*/_jsx(Icon, {
      className: IconConstants.X,
      fontSize: size
    })
  });
}